import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { portalApi, formatPortalError, getPortalUser, setPortalSession } from "@/api/portalClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound, Loader2, AlertTriangle } from "lucide-react";

export default function EmployeePortalChangePassword() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    if (next !== confirm) return toast.error("Uudet salasanat eivät täsmää");
    if (next.length < 8) return toast.error("Salasanan on oltava vähintään 8 merkkiä pitkä");
    setSaving(true);
    try {
      await portalApi.post("/employee-portal/change-password", { current_password: current, new_password: next });
      // Päivitä localStorageen tieto että ei tarvi pakottaa enää
      const u = getPortalUser() || {};
      setPortalSession(localStorage.getItem("emp_portal_token"), { ...u, must_change_password: false });
      toast.success("Salasana vaihdettu – tervetuloa!");
      navigate("/employee-portal", { replace: true });
    } catch (err) { toast.error(formatPortalError(err)); }
    setSaving(false);
  };

  return (
    <div className="app-bg flex items-center justify-center px-4 py-12 min-h-screen" data-testid="emp-portal-change-pw">
      <div className="w-full max-w-md">
        <div className="glass-card p-8 space-y-5">
          <div className="text-center relative z-10">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-400 to-purple-600 flex items-center justify-center mx-auto mb-3">
              <KeyRound className="w-7 h-7 text-white" />
            </div>
            <h1 className="text-xl font-display gradient-text-luxe">Vaihda salasana</h1>
            <p className="text-xs text-white/50 mt-2">Ensimmäisellä kirjautumisella sinun täytyy vaihtaa tilapäinen salasana.</p>
          </div>
          <form onSubmit={submit} className="space-y-3 relative z-10">
            <div>
              <Label className="text-xs text-white/70">Nykyinen (tilapäinen) salasana</Label>
              <Input type="password" value={current} onChange={e => setCurrent(e.target.value)} className="mt-1 bg-black/30 border-white/10" data-testid="cp-current" autoFocus />
            </div>
            <div>
              <Label className="text-xs text-white/70">Uusi salasana (vähintään 8 merkkiä)</Label>
              <Input type="password" value={next} onChange={e => setNext(e.target.value)} className="mt-1 bg-black/30 border-white/10" data-testid="cp-next" />
            </div>
            <div>
              <Label className="text-xs text-white/70">Vahvista uusi salasana</Label>
              <Input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} className="mt-1 bg-black/30 border-white/10" data-testid="cp-confirm" />
            </div>
            <Button type="submit" disabled={saving} className="btn-luxe w-full inline-flex items-center justify-center gap-2" data-testid="cp-submit">
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <KeyRound className="w-4 h-4" />}
              Tallenna ja jatka
            </Button>
          </form>
          <div className="rounded-lg bg-amber-500/10 border border-amber-500/30 p-3 text-xs text-amber-100 flex gap-2 relative z-10">
            <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5 text-amber-300" />
            <p>Valitse vahva salasana – tämä on omasta turvallisuudestasi.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
